// "container page" refers to anything built through the ProductLandingPage template, so including subcategories pages
const BOOTCAMP_CONTAINER_PAGE = 'bootcamp-container-page';
const BOOTCAMP_OR_MICRO_BOOTCAMP_ABOUT_PAGE = 'bootcamp-or-microbootcamp-about-page';
const MICRO_BOOTCAMP_CONTAINER_PAGE = 'microbootcamp-container-page';
const EXEC_ED_CONTAINER_PAGE = 'executive-education-container-page';
const EXEC_ED_ABOUT_PAGE = 'executive-education-about-page';
const MASTERS_CONTAINER_PAGE = 'masters-container-page';
const BACHELORS_CONTAINER_PAGE = 'bachelors-container-page';
const DOCTORATE_CONTAINER_PAGE = 'doctorate-container-page';
// degree refers to 2U degrees, which currently comprises master's, bachelor's, and doctorate and have a XX
const DEGREE_ABOUT_PAGE = 'degree-about-page';
const OPEN_COURSE_ABOUT_PAGE = 'open-course-about-page';
const MICRO_MASTERS_CONTAINER_PAGE = 'micromasters-container-page';
const MICRO_MASTERS_ABOUT_PAGE = 'micromasters-about-page';
const MICRO_BACHELORS_CONTAINER_PAGE = 'microbachelors-container-page';
const MICRO_BACHELORS_ABOUT_PAGE = 'microbachelors-about-page';
const PROFESSIONAL_CERTIFICATE_CONTAINER_PAGE = 'professional-certificate-container-page';
const PROFESSIONAL_CERTIFICATE_ABOUT_PAGE = 'professional-certificate-about-page';

const BOOTCAMP_PAGES = [
  BOOTCAMP_CONTAINER_PAGE,
  BOOTCAMP_OR_MICRO_BOOTCAMP_ABOUT_PAGE,
  MICRO_BOOTCAMP_CONTAINER_PAGE,
];

const EXEC_ED_PAGES = [
  EXEC_ED_CONTAINER_PAGE,
  EXEC_ED_ABOUT_PAGE,
];

const DEGREE_PAGES = [
  MASTERS_CONTAINER_PAGE,
  BACHELORS_CONTAINER_PAGE,
  DOCTORATE_CONTAINER_PAGE,
  DEGREE_ABOUT_PAGE,
];

const OPEN_COURSE_PAGES = [
  OPEN_COURSE_ABOUT_PAGE,
];

const MICRO_MASTERS_PAGES = [
  MICRO_MASTERS_CONTAINER_PAGE,
  MICRO_MASTERS_ABOUT_PAGE,
];

const MICRO_BACHELORS_PAGES = [
  MICRO_BACHELORS_CONTAINER_PAGE,
  MICRO_BACHELORS_ABOUT_PAGE,
];

const PROFESSIONAL_CERTIFICATE_PAGES = [
  PROFESSIONAL_CERTIFICATE_CONTAINER_PAGE,
  PROFESSIONAL_CERTIFICATE_ABOUT_PAGE,
];

const getProductLandingPageType = (productType) => {
  let page = '';
  switch (productType) {
    case 'Boot Camp':
      page = BOOTCAMP_CONTAINER_PAGE;
      break;
    case 'Master\'s':
      page = MASTERS_CONTAINER_PAGE;
      break;
    case 'Bachelor\'s':
      page = BACHELORS_CONTAINER_PAGE;
      break;
    case 'Executive Education':
      page = EXEC_ED_CONTAINER_PAGE;
      break;
    case 'MicroMaster\'s':
      page = MICRO_MASTERS_CONTAINER_PAGE;
      break;
    case 'MicroBachelor\'s':
      page = MICRO_BACHELORS_CONTAINER_PAGE;
      break;
    case 'Professional Certificate':
      page = PROFESSIONAL_CERTIFICATE_CONTAINER_PAGE;
      break;
    case 'MicroBootCamp':
      page = MICRO_BOOTCAMP_CONTAINER_PAGE;
      break;
    case 'Doctorate':
      page = DOCTORATE_CONTAINER_PAGE;
      break;
    default:
      page = 'default';
  }
  return page;
};

module.exports = {
  BOOTCAMP_OR_MICRO_BOOTCAMP_ABOUT_PAGE,
  EXEC_ED_ABOUT_PAGE,
  DEGREE_ABOUT_PAGE,
  OPEN_COURSE_ABOUT_PAGE,
  MICRO_MASTERS_ABOUT_PAGE,
  MICRO_BACHELORS_ABOUT_PAGE,
  PROFESSIONAL_CERTIFICATE_CONTAINER_PAGE,
  PROFESSIONAL_CERTIFICATE_ABOUT_PAGE,
  BOOTCAMP_PAGES,
  EXEC_ED_PAGES,
  DEGREE_PAGES,
  OPEN_COURSE_PAGES,
  MICRO_MASTERS_PAGES,
  MICRO_BACHELORS_PAGES,
  PROFESSIONAL_CERTIFICATE_PAGES,
  getProductLandingPageType,
};
